import React from 'react';
import { useTranslation } from 'react-i18next';
import { PieChart } from 'lucide-react';
import { DataTable } from './UIComponents';
import { formatPrice, formatPercent } from './formatters';

const StockRatios = ({ data }) => {
  const { t } = useTranslation();
  const ratiosData = [
    { label: t('stocks.fields.peRatioTtm'), value: data.peRatio ? data.peRatio.toFixed(2) : '--' },
    { label: t('stocks.fields.earningsYield'), value: formatPercent(data.earningsYield) },
    { label: t('stocks.fields.priceToSalesTtm'), value: data.priceToSales ? data.priceToSales.toFixed(2) : '--' },
    { label: t('stocks.fields.priceToBookMrq'), value: data.priceToBook ? data.priceToBook.toFixed(2) : '--' },
    { label: t('stocks.fields.epsTtm'), value: formatPrice(data.eps) },
    { label: t('stocks.fields.bookValuePerShare'), value: formatPrice(data.bookValue) },
    { label: t('stocks.fields.grossMargin'), value: formatPercent(data.grossMargin) },
    { label: t('stocks.fields.operatingMargin'), value: formatPercent(data.operatingMargin) },
    { label: t('stocks.fields.netMargin'), value: formatPercent(data.netMargin) },
    { label: t('stocks.fields.roe'), value: formatPercent(data.roe) },
    { label: t('stocks.fields.roa'), value: formatPercent(data.roa) },
    { label: t('stocks.fields.currentRatio'), value: data.currentRatio ? data.currentRatio.toFixed(2) : '--' },
    { label: t('stocks.fields.debtToEquity'), value: data.debtToEquity ? data.debtToEquity.toFixed(2) : '--' },
  ];

  return (
    <div className="space-y-8">
      <DataTable
        title={t('stocks.tableTitles.valuationRatios')}
        icon={PieChart}
        data={ratiosData}
        defaultExpanded={true}
      />
    </div>
  );
};

export default StockRatios;